
import moment from 'moment';
let GetDateFormat = (date, maintenantFormat) => {
  const displayDate = moment(date, maintenantFormat ).format('DD/MM/YYYY' );
  if ( date === "now" || date  === "Maintenant" || date === "Non-stop" || date === "Without ending date" || date === "Sans date de fin") {
    return date
  } else if (displayDate === 'Invalid date') {
    return '';
  }
  return displayDate;
}

export default GetDateFormat;



// WEBPACK FOOTER //
// ./src/lib/date/GetDateFormat.js